import { render, staticRenderFns } from "./SpeechTips.vue?vue&type=template&id=09db8752&"
import script from "./SpeechTips.vue?vue&type=script&lang=ts&"
export * from "./SpeechTips.vue?vue&type=script&lang=ts&"
import style0 from "./SpeechTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports